module.exports = __webpack_public_path__ + "static/dd-madde6-1bd45f10d38648082b692d3083dbb553.png";